import React from 'react';
import { useSelector } from 'react-redux';
import { useShouldShowFullAddress } from 'hooks/useShouldShowFullAddress';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';

export const useMarketplace = () => {
    return useSelector(getMarketplace);
};

export const useMarketplaceAddress = () => {
    const marketplace = useMarketplace();
    const shouldShowFullAddress = useShouldShowFullAddress();

    const marketplaceAddress = React.useMemo(() => {
        const address: Array<string> = [];

        if (shouldShowFullAddress) {
            let addressLines = '';

            addressLines += marketplace.address?.addressLineOne.trim();

            if (marketplace.address?.addressLineTwo) {
                addressLines += ` ${marketplace.address?.addressLineTwo.trim()}`;
            }

            address.push(addressLines + ',');
        }

        address.push(`${marketplace.address?.city.trim()} ${marketplace.address?.state.trim()},`);

        if (shouldShowFullAddress) {
            address.push(marketplace.address?.zipcode.trim() ?? '');
        }

        return address.join(' ');
    }, [marketplace, shouldShowFullAddress]);

    return {
        marketplaceAddress
    };
};
